export default {
  'Screenshot': 'स्क्रीनशॉट',
}